import { type ReactNode } from 'react'

import { Layout, Text } from '@loadsmart/miranda-react'

import { clamp } from 'core/utils/number'

import { Bar, Progress } from './ProgressBar.styles'

type ProgressBarProps = {
  value?: number
  label?: string
  icon?: ReactNode
}

export function ProgressBar({ value = 0, label, icon }: ProgressBarProps) {
  const clampedValue = clamp(value)

  return (
    <Layout.Group align="center" gap="spacing-2">
      <Bar role="progressBar" aria-valuenow={clampedValue} aria-valuemin={0} aria-valuemax={100}>
        <Progress $value={clampedValue} data-testid="progress-bar" />
      </Bar>
      <Layout.Group align="center" gap="spacing-1">
        {label && <Text variant="body-sm">{label}</Text>}
        {icon}
      </Layout.Group>
    </Layout.Group>
  )
}
